import cn from 'classnames';

import { defineTheme, type ThemeKeys } from 'js/utils/theme-helpers';

import Icon from 'components/icon/Icon';

import InputControlled from './InputControlled';
import InputUncontrolled from './InputUncontrolled';

import { ICheckbox } from 'source/NFR.types';

const themes = defineTheme({
  gray: 'checkbox--theme-gray',
  blue: 'checkbox--theme-blue'
});
type Theme = ThemeKeys<typeof themes>;

interface ICheckboxProps extends ICheckbox {
  className?: string;
  isControlled?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  theme?: Theme;
  isDisabled?: boolean;
  id?: string;
}

const Checkbox: React.FC<ICheckboxProps> = ({
  className,
  checked = false,
  label = '',
  name,
  onChange,
  theme = 'blue',
  value,
  dataId,
  isControlled
}) => {
  const id = `checkbox-${name}-${label.replace(/ /g, '_')}`;
  const Input = isControlled ? InputControlled : InputUncontrolled;

  return (
    <div className={cn('checkbox', themes(theme), className)}>
      <Input id={id} name={name} label={label} onChange={onChange} value={value} checked={checked} dataId={dataId} />
      <label htmlFor={id}>
        <span>{label}</span>
        <Icon fill className="checkbox--checkmark" name="checkmark" />
      </label>
    </div>
  );
};

Checkbox.displayName = 'Checkbox';

export default Checkbox;
